module.exports = __webpack_public_path__ + "assets/img/driver-btn-576ec0cb.png";